export const signin = {
  title: 'Authentification',
  mandatoryFields: '* : Champs obligatoires',
  banner: {
    password:
      'Saisir votre identifiant (email) ainsi que votre mot de passe puis cliquer sur "Se connecter".',
  },
  msgErrors: 'Erreurs dans le formulaire',
  loader: {
    label: 'Chargement',
    msg: "Vérification des informations d'authentification...",
  },
  remember:
    'Se souvenir (décochez cette case en cas de connexion depuis un appareil qui ne vous appartient pas)',
  forgottenPass: {
    label: 'Mot de passe oublié ?',
    title: {
      onLine: 'Procédure de récupération de mot de passe',
      offLine: 'En attente de réseau...',
    },
  },
  signupBtn: {
    label: "S'inscrire",
    title: {
      onLine: "Créer un compte pour accéder au contenu de l'application MaVEL",
      offLine: 'En attente de réseau...',
    },
  },
  signinOk: {
    label: 'Se connecter',
    loading: 'Chargement...',
  },
  signinCancel: {
    label: 'Annuler',
  },
  mobileBanner:
    'Le mot de passe et le code secret sont nécessaires à la première connexion. Pour les connexions suivantes, uniquement le code secret ou le mot de passe sera demandé (à condition de cliquer sur "Se souvenir de l\'identifiant").',
  login: {
    form: {
      error01: "L'adresse mail est obligatoire.",
      error02: "L'adresse mail est invalide.",
      error03: 'Le mot de passe est obligatoire.',
      error04: 'Le code secret est obligatoire.',
      error05: 'Le mot de passe doit respecter les règles de sécurité.',
      error06: 'Le code secret doit respecter les règles de sécurité.',
    },
    error: {
      unknown: 'Erreur inconnue...',
      LOGGING_OUT_ERROR: 'Utilisateur en cours de déconnexion',
      AUTH_ERR_01:
        "Données non valides.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_02:
        "Jeton CSRF invalide.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_03:
        "Jeton CSRF inconnu.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_04:
        "Données non valides.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_05:
        "Données non valides.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_06:
        "Données non valides.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_07:
        "Identifiant ou mot de passe incorrect.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_08:
        "Votre compte n'est pas actif.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_09:
        "Identifiant ou mot de passe incorrect.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}.",
      AUTH_ERR_10:
        'Le mot de passe temporaire a expiré. Veuillez rejouer la procédure de mot de passe oublié.',
      AUTH_ERR_RATE_LIMIT:
        "Le nombre d'essais autorisés est atteint.<br>Veuillez réitérer le {rateLimitReset}.",
      AUTH_DATABASE_ERR_01:
        "Erreur technique (temps d'inactivité dépassé). Veuillez vous authentifier de nouveau.",
      AUTH_ERR_OFFLINE_01_1:
        'Il semble que le serveur distant soit inaccessible (appareil non connecté à internet ou serveur distant indisponible).',
      AUTH_ERR_OFFLINE_01_2:
        'Pour la première connexion, vous devez être en ligne (accès à internet activé).',
      AUTH_ERR_OFFLINE: 'Pour la première connexion, vous devez être en ligne (soit vous n\'êtes pas connecté à internet soit le serveur distant rencontre un dysfonctionnement).'
    },
  },
  logout: {
    message: 'Déconnexion réussie',
    error:
      'Une erreur technique est intervenue lors de la mise à jour de la session.',
  },
};
